<div
  #panelEl
  [attr.aria-labelledby]="tabId"
  [class.active]="active"
  [id]="name"
  role="tabpanel"
  [tabindex]="tabindex"
>
  <ng-content></ng-content>
</div>
